<style lang="scss">
#roadviewControl {
    position: absolute;
    top: 5px;
    right: 60%;
    width: 42px;
    height: 42px;
    z-index: 1;
    cursor: pointer;
    background: url('https://t1.daumcdn.net/localimg/localimages/07/2018/pc/common/img_search.png') 0 -450px no-repeat;
}
.item-search {
  display: none;
  position: absolute;
  top: 50px;
  z-index: 101;
  height: 30px;
  .search-input {
    width: calc(100% - 110px);
    height: 47px;
    padding: 0;
    border-radius: 15px;
    box-shadow: 1px 1px 10px 5px rgba(1, 1, 1, 0.2);
    transition: 0.6s ease;
    &:hover {
      box-shadow: 0 10px 10px -8px rgba(1, 1, 1, 0.8);
    }
    &:focus {
      box-shadow: 0 0 5pt 2pt #d3d3d3;
    }
    > div {
      width: 100%;
      height: 47px;
      ul {
        padding: 5px 0;
        > li {
          padding: 5px 0;
        }
      }
      > input {
        width: 100%;
        height: 100%;
        caret-color: #000;
        position: relative;
        display: block;
        border-radius: 10px;
        border: 3px solid #e8dddd;
        outline: none;
        padding: 10px;
        box-sizing: border-box;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
      }
    }
    .autosuggest__results {
      height: 200px;
      overflow: hidden;
      overflow-y: auto;
      background: #fff;
      border: 1px solid #c1c1c1;
    }
  }
  &.active {
    display: flex;
    justify-content: center;
    align-items: center;
    width: calc(82% - 400px);
    right: 100px;
    top: 180px;
  }
  .search-router {
    /*        width: 67px;
            height: 47px;
            background: #266B8E;
            line-height: 35px;
            display: inline-block;
            text-align: center;
            color: #fff;
            font-size: 16px;
            font-weight: bold;
            border-radius: 0 10px 10px 0;*/
    width: 67px;
    top: -4px;
    right: 60px;
    position: absolute;
    height: 38px;
    background: #266b8e;
    line-height: 35px;
    display: inline-block;
    text-align: center;
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    border-radius: 10px;
  }
}
@media only screen and (max-device-width: 1300px) {
  .item-search {
    display: none;
    position: absolute;
    top: 50px;
    height: 30px;
    .search-input {
      width: calc(100% - 110px);
      height: 47px;
      padding: 0;
      border-radius: 15px;
      box-shadow: 1px 1px 10px 5px rgba(1, 1, 1, 0.2);
      transition: 0.6s ease;
      &:hover {
        box-shadow: 0 10px 10px -8px rgba(1, 1, 1, 0.8);
      }
      &:focus {
        box-shadow: 0 0 5pt 2pt #d3d3d3;
      }
      > div {
        width: 100%;
        height: 47px;
        ul {
          padding: 5px 0;
          > li {
            padding: 5px 0;
          }
        }
        > input {
          width: 100%;
          height: 100%;
          caret-color: #000;
          position: relative;
          display: block;
          border-radius: 10px;
          border: 3px solid #e8dddd;
          outline: none;
          padding: 10px;
          box-sizing: border-box;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
        }
      }
      .autosuggest__results {
        height: 200px;
        overflow: hidden;
        overflow-y: auto;
        background: #fff;
        border: 1px solid #c1c1c1;
      }
    }
    &.active {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(100% - 160px);
      top: 140px;
    }
    .search-router {
      width: 67px;
      top: -4px;
      right: 60px;
      position: absolute;
      height: 38px;
      background: #266b8e;
      line-height: 35px;
      display: inline-block;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      border-radius: 10px;
    }
  }
}
@media only screen and (max-device-width: 580px) {
  .map-area {
    height: 23% !important;
  }
  .urban-sub {
    .search-aside {
      top: unset !important;
      bottom: 70%;
      width: 100% !important;
      height: 250px !important;
      z-index: 101 !important;
      overflow: hidden;
      display: block;
      .chk-area {
        display: none;
      }
      .aside-contents {
        padding-top: 20px;
        background: #fff;
        .column-top {
          position: relative;
          padding: 0 20px 15px 20px;
          .tit {
            font-size: 20px;
            font-weight: 700;
            line-height: 10px;
            letter-spacing: -1px;
            .light {
              font-weight: normal;
            }
            .total {
              color: #006a92;
              font-weight: bold;
            }
          }
        }
        .column-bottom {
          overflow-x: scroll;
        }
        a:hover {
          .estate-item-area {
            background: #e5f0f4;
          }
        }
        .estate-item-area {
          padding-left: 10px;
          .thumb {
            width: 100px;
            height: 60px;
            img {
              width: 100px;
              height: 60px;
            }
          }
          .desc {
            overflow: hidden;
            margin-left: 10px;
            width: 100px;
          }
          .label {
            width: 70px;
            height: 22px;
            background: #006a92;
            border-radius: 10px;
            text-align: center;
            color: #fff;
            font-size: 12px;
            line-height: 22px;
            font-weight: bold;
          }
          .address {
            padding-top: 5px;
            color: #006a92;
            font-size: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .detail {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            color: #9fa0a0;
            width: 99%;
          }
        }
        .search-list {
          display: flex;
        }
        .list-item {
          margin-bottom: 7px;
        }
      }
    }
    .aside-hidden {
      display: none;
    }
  }
  .item-search {
    display: none;
    position: absolute;
    top: 50px;
    height: 30px;
    .search-input {
      width: calc(100% - 110px);
      height: 47px;
      padding: 0;
      border-radius: 15px;
      box-shadow: 1px 1px 10px 5px rgba(1, 1, 1, 0.2);
      transition: 0.6s ease;
      &:hover {
        box-shadow: 0 10px 10px -8px rgba(1, 1, 1, 0.8);
      }
      &:focus {
        box-shadow: 0 0 5pt 2pt #d3d3d3;
      }
      > div {
        width: 100%;
        height: 47px;
        ul {
          padding: 5px 0;
          > li {
            padding: 5px 0;
          }
        }
        > input {
          width: 100%;
          height: 100%;
          caret-color: #000;
          position: relative;
          display: block;
          border-radius: 10px;
          border: 3px solid #e8dddd;
          outline: none;
          padding: 10px;
          box-sizing: border-box;
          -webkit-box-sizing: border-box;
          -moz-box-sizing: border-box;
        }
      }
      .autosuggest__results {
        height: 200px;
        overflow: hidden;
        overflow-y: auto;
        background: #fff;
        border: 1px solid #c1c1c1;
      }
    }
    &.active {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      left: 0;
      top: 140px;
    }
    .search-router {
      width: 67px;
      top: -4px;
      right: 60px;
      position: absolute;
      height: 38px;
      background: #266b8e;
      line-height: 35px;
      display: inline-block;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      border-radius: 10px;
    }
  }
}
@media screen and (max-height: 586px) {
  .map-area {
    height: 22% !important;
  }
  .urban-sub {
    .search-aside {
      top: unset !important;
      bottom: 75%;
      width: 100% !important;
      height: 150px !important;
      z-index: 101 !important;
      overflow: hidden;
      display: block;
    }
  }
}
</style>
<template>
  <div class="urban-asset">
    <div class="urban-sub">
      <aside class="search-aside" :class="{ 'aside-hidden': asideHidden }">
        <div class="chk-area"></div>
        <div class="aside-contents">
          <div class="column-top">
            <h2 class="tit">
              {{ titleStr }}
              <span class="light"
                >물건 <span class="total">{{ itemResults.length }}</span
                >건</span
              >
            </h2>
            <!--<button type="button" class="filter-large">고액순</button>-->
          </div>
          <div class="column-bottom">
            <ul class="search-list">
              <li
                class="list-item"
                v-for="(item, index) in itemResults"
                :key="index"
              >
                <!--<router-link :to="to" @click.native="moveEstateById(item.estateId)">-->
                <router-link
                  :to="{ name: 'ViewEstate', params: { id: item.estateId } }"
                >
                  <!--<a :href="'ViewEstate/' + item.estateId" target="_blank">-->
                  <div class="estate-item-area" @click="getData">
                    <div class="thumb">
                      <img
                        v-if="item.imgSrc === ''"
                        src="../img/thumbnail-large.jpg"
                        alt=""
                      />
                      <img
                        v-else
                        :src="
                          $store.state.common.urlpath +
                            '/uploads/' +
                            item.imgSrc
                        "
                        alt=""
                      />
                    </div>
                    <div class="desc">
                      <div class="label" v-if="item.label === 'true'">
                        추천매물
                      </div>
                      <div class="address">{{ item.address }}</div>
                      <div class="detail">{{ item.detail }}</div>
                    </div>
                  </div>
                </router-link>
              </li>
              <li></li>
            </ul>
          </div>
        </div>
      </aside>
      <div
        class="item-set"
        :style="[
          asideHidden
            ? { left: '0 !important' }
            : windowWidth <= 700
            ? { left: '0 !important' }
            : { left: '508px !important' }
        ]"
      >
        <button
          type="button"
          v-for="(button, index) in itemKinds"
          :key="index"
          class="item-btn"
          :class="{ active: button.isActive }"
          @click="activateButton(button)"
        >
          <i class="icon" :class="button.class"></i
          ><span class="tit">{{ button.tit }}</span>
        </button>
        <button
          type="button"
          class="item-btn"
          :class="{ active: checkAllItem.isActive }"
          @click="isActiveAllCheck()"
        >
          <i class="icon" :class="checkAllItem.class"></i>
          <span class="tit">{{ checkAllItem.tit }}</span>
        </button>
        <!-- <div id="roadviewControl" class=""></div> -->
      </div>

      <section class="map-area">
        <div id="map" ></div>
      </section>
    </div>
    <div class="item-search active">
      <vue-autosuggest
        ref="autosuggest"
        v-model="query"
        @click="clickHandler"
        @selected="selectHandler"
        :suggestions="filteredSuggestions"
        :inputProps="inputProps"
        :getSuggestionValue="s => s.item.searcheKey"
        class="search-input"
      >
        <template slot-scope="{ suggestion }">
          <div>
            <b>{{ suggestion.item.searcheKey }}</b>
          </div>
        </template>
      </vue-autosuggest>
      <button class="search-router" @click="clickMove()">검색</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SearchEstate',
  data () {
    return {
      asideHidden: false, // aside hidden 처리
      screenWidth: screen.width, // aside hidden 처리
      // this css class are used in style.scss
      checkAllItem: {
        tit: '전체',
        class: 'first',
        isActive: false,
        color: 'red'
      },
      // this item is for map marker
      itemKinds: [
        {
          tit: '주거',
          class: 'first',
          isActive: true,
          typeCode: '001',
          color: 'red'
        },
        {
          tit: '토지',
          class: 'second',
          isActive: true,
          typeCode: '002',
          color: 'orange'
        },
        {
          tit: '상가',
          class: 'third',
          isActive: true,
          typeCode: '003',
          color: 'yellow'
        },
        {
          tit: '오피스',
          class: 'fourth',
          isActive: true,
          typeCode: '004',
          color: 'green'
        },
        {
          tit: '건물',
          class: 'fifth',
          isActive: true,
          typeCode: '005',
          color: 'blue'
        },
        {
          tit: '산업 용지',
          class: 'sixth',
          isActive: true,
          typeCode: '006',
          color: 'navy'
        },
        {
          tit: '골프',
          class: 'seventh',
          isActive: true,
          typeCode: '007',
          color: 'teal'
        },
        {
          tit: '콘도',
          class: 'eighth',
          isActive: true,
          typeCode: '008',
          color: 'purple'
        },
        {
          tit: '공모',
          class: 'ninth',
          isActive: true,
          typeCode: '009',
          color: 'magenta'
        }
      ],
      titleStr: '',
      query: '',
      isActive: false,
      topMenuOpen: false,
      windowWidth: window.innerWidth,
      inputProps: {
        id: 'autosuggest__input',
        placeholder: '원하시는 지역을 입력해주세요.',
        class: 'autosuggest_input'
      },
      zoomLevel: 7,
      latPosition: 37.50414344227525,
      lngPosition: 127.04632124002055,
      map: null,
      geocoder: null,
      overlays: [],
      componentKey: 0
    }
  },
  watch: {
    query () {
      if (this.query.length !== 0) {
        this.$store.dispatch('apiSearchList', {
          keyword: this.query.replace(/ /g, ''),
          method: 'GET'
        })
      } else {
        this.suggestions = []
      }
    },

    positions () {
      let idList = []
      this.setOverlays()
      let tmpThis = this
      this.positions.forEach(function (pos) {
        let tmpMap = tmpThis.map
        let itemKind = tmpThis.itemKinds
        // console.log(itemKind)
        let selectBtn = document.createElement('button')
        selectBtn.className =
          'marker ' + tmpThis.getColors(itemKind, pos.codeType)
        let markerStr = tmpThis.getMarkerDiv(pos)
        selectBtn.appendChild(markerStr)
        let customOverlay = new window.kakao.maps.CustomOverlay({
          map: tmpMap,
          position: new window.kakao.maps.LatLng(pos.markerLat, pos.markerLng),
          content: selectBtn,
          clickable: true,
          xAnchor: 0.5,
          yAnchor: 1.05
        })
        selectBtn.onclick = function () {
          tmpThis.clickMarker(pos)
        }
        tmpThis.overlays.push(customOverlay)
        if (pos.estateId && typeof pos.estateId !== 'undefined') {
          idList.push(pos.estateId)
        }
      })
      if (idList.length > 0) {
        this.asideHidden = false
        // document.querySelector('.item-set').style.left = '508px !important'
        this.$store.dispatch('apiEstateDetail', {
          latPosition: this.latPosition,
          lngPosition: this.lngPosition,
          idList: idList
        })
      } else {
        this.asideHidden = true
        // document.querySelector('.item-set').style.left = '0 !important'
        // console.log('ggg')
        this.$$store.dispatch('getDataIdList', [])
        if (this.getCustomLevel() === 4) {
          this.$store.commit('setDetails', [])
        }
      }
    }
  },

  mounted () {
    if (this.$store.getters.getListSearch.length > 0) {
      this.itemKinds = this.$store.getters.getListSearch
    }
    this.componentKey += 1
    if (window.kakao && window.kakao.maps) {
      this.initLocations()
    } else {
      const script = document.createElement('script')
      script.onload = () => window.kakao.maps.load(this.initLocations)
      script.src =
        '//dapi.kakao.com/v2/maps/sdk.js?autoload=false&appkey=2cc975adfb1b149255c44f49d88a036b&libraries=services'
      document.head.appendChild(script)
      this.initLocations()
    }
  },
  methods: {
    // streetView (latPosition, lngPosition) {
    //   var roadviewContainer = document.getElementById('map')
    //   var roadview = new window.kakao.maps.Roadview(roadviewContainer)
    //   var roadviewClient = new window.kakao.maps.RoadviewClient()
    //   var position = new window.kakao.maps.LatLng(
    //     latPosition,
    //     lngPosition
    //   )

    //   roadviewClient.getNearestPanoId(position, 50, function (panoId) {
    //     roadview.setPanoId(panoId, position)
    //   })
    // },
    // showStreetView () {
    //   const mapContainer = document.getElementById('map')
    //   const mapOption = {
    //     center: new window.kakao.maps.LatLng(
    //       this.latPosition,
    //       this.lngPosition
    //     ), // 지도의 중심좌표
    //     level: 3 // 지도의 확대 레벨
    //   }
    //   var map = new window.kakao.maps.Map(mapContainer, mapOption)
    //   map.addOverlayMapTypeId(window.kakao.maps.MapTypeId.ROADVIEW)
    // },
    getData () {
      return this.$store.dispatch('setListSearch', this.itemKinds)
    },
    isActiveAllCheck: function () {
      if (this.checkAllItem.isActive) {
        this.itemKinds = this.itemKinds.map(e => {
          return {
            ...e,
            isActive: false
          }
        })
      } else {
        this.itemKinds = this.itemKinds.map(e => {
          return {
            ...e,
            isActive: true
          }
        })
      }
      this.checkAllItem.isActive = !this.checkAllItem.isActive
      let mapThis = this.$store.getters.getMapThis
      this.getActiveKind()
      mapThis.viewMarkers()
    },
    activateButton: function (activatedButton) {
      if (this.checkAllItem.isActive) {
        this.checkAllItem.isActive = false
      }

      activatedButton.isActive = !activatedButton.isActive
      let mapThis = this.$store.getters.getMapThis
      this.getActiveKind()
      mapThis.viewMarkers()
    },
    getActiveKind () {
      let array = []
      for (let i = 0; i < this.itemKinds.length; i++) {
        if (this.itemKinds[i].isActive) {
          array.push(this.itemKinds[i].typeCode)
        }
      }
      return array
    },
    clickHandler (item) {
      this.loading = false
    },
    selectHandler (item) {
      if (item) {
        this.query = item.item.searcheKey
        this.clickItem = item.item
      }
    },
    blurHandler () {
      if (this.$options.name === 'Main') {
        this.fullpageScrollStart()
      }
    },
    focusHandler () {
      if (this.$options.name === 'Main') {
        this.fullpageScrollStop()
      }
    },
    clickMove () {
      this.query = ''
      if (this.clickItem !== '') {
        sessionStorage.setItem('lat', this.clickItem.lat)
        sessionStorage.setItem('lng', this.clickItem.lng)
        if (sessionStorage.getItem('level') === null) {
          sessionStorage.setItem('level', 3)
        }
        this.clickItem = ''
        this.$router.go('/SearchEstate')
      } else {
        alert('지역을 다시 선택해 주세요')
      }
    },
    getMarkerDiv: function (obj) {
      const markerDiv = document.createElement('div')
      markerDiv.className = 'markerDiv'

      const markerName = document.createElement('span')
      markerName.className = 'markerName'

      const markerPrice = document.createElement('span')
      markerPrice.className = 'markerPrice'
      let price = this.changePrice(obj.price)
      const deposite = obj.deposite
      if (deposite !== 0) {
        price = this.changePrice(deposite) + ' / ' + price
      }
      const eCount = obj.markerCount + '건'
      if (obj.markerName === '') {
        markerPrice.appendChild(document.createTextNode(price))
        markerDiv.appendChild(markerPrice)
      } else {
        markerName.appendChild(document.createTextNode(obj.markerName))
        // markerPrice.appendChild(document.createTextNode(price))
        markerPrice.appendChild(document.createTextNode(eCount))
        markerDiv.appendChild(markerName)
        markerDiv.appendChild(markerPrice)
      }
      return markerDiv
    },
    clickMarker (pos) {
      const customLevel = this.getCustomLevel()
      if (customLevel <= 2) {
        alert(
          '현재 상태에서는 상세 매물을 볼 수 없습니다. \n더 확대하시면 보입니다.'
        )
      } else if (customLevel === 3) {
        this.asideHidden = false
        this.$store.dispatch('apiEstateSelectDetail', {
          latPosition: pos.markerLat,
          lngPosition: pos.markerLng,
          zoomLevel: customLevel,
          keyWord: pos.markerName
        })
        this.titleStr = pos.markerName
      } else {
        this.asideHidden = false
        this.$store.dispatch('apiEstateSelectDetail', {
          latPosition: pos.markerLat,
          lngPosition: pos.markerLng,
          zoomLevel: customLevel
        })
        this.titleStr = '선택 된 '
      }
      if (pos.estateId) {
        this.goDetailsView(pos.estateId)
      }
    },
    viewMarkers () {
      let kinds = this.getActiveKind()
      this.$store.dispatch('apiEstateMarker', {
        zoomLevel: this.zoomLevel,
        latPosition: this.latPosition,
        lngPosition: this.lngPosition,
        codeList: kinds
      })
    },
    getColors (tmpKind, targetType) {
      let strColer = 'black'
      for (let i = 0; i < tmpKind.length; i++) {
        if (tmpKind[i].typeCode === targetType) {
          return tmpKind[i].color
        }
      }
      return strColer
    },
    setOverlays () {
      if (this.overlays.length > 0) {
        for (let i = 0; i < this.overlays.length; i++) {
          this.overlays[i].setMap(null)
        }
      }
      this.overlays = []
    },
    searchAddrFromCoords (coords, callback) {
      // 좌표로 행정동 주소 정보를 요청합니다
      this.geocoder.coord2RegionCode(
        coords.getLng(),
        coords.getLat(),
        callback
      )
    },
    getCustomLevel () {
      let level = 4
      if (this.zoomLevel >= 11) {
        level = 1
      } else if (this.zoomLevel >= 8) {
        level = 2
      } else if (this.zoomLevel >= 5) {
        level = 3
      }
      return level
    },
    displayCenterInfo (result, status) {
      let titleStr = this.titleStr
      const customLevel = this.getCustomLevel()
      if (customLevel <= 3) {
        // 현재는 3까지 잡혀 있으나 나중에 필요한 경우 3은 풀 수 있도록 조정이 필요
        return
      }
      if (status === window.kakao.maps.services.Status.OK) {
        if (customLevel === 4) {
          titleStr = result[1].region_3depth_name
          this.titleStr = titleStr + ' 주변'
        }
      }
    },
    setDragEndEvent () {
      try {
        this.zoomLevel = this.map.getLevel()
        const latlng = this.map.getCenter()
        this.latPosition = latlng.getLat()
        this.lngPosition = latlng.getLng()

        sessionStorage.setItem('lat', this.latPosition)
        sessionStorage.setItem('lng', this.lngPosition)
        sessionStorage.setItem('level', this.zoomLevel)

        this.searchAddrFromCoords(latlng, this.displayCenterInfo)

        const customLevel = this.getCustomLevel()
        if (customLevel <= 2) {
          this.asideHidden = true
        }
        this.viewMarkers()
      } catch (err) {
        this.$router.go(0)
      }
    },
    setZoomEvent () {
      try {
        this.zoomLevel = this.map.getLevel()
        const latlng = this.map.getCenter()
        this.latPosition = latlng.getLat()
        this.lngPosition = latlng.getLng()
        sessionStorage.setItem('lat', this.latPosition)
        sessionStorage.setItem('lng', this.lngPosition)
        sessionStorage.setItem('level', this.zoomLevel)
        this.searchAddrFromCoords(latlng, this.displayCenterInfo)
        const customLevel = this.getCustomLevel()
        if (customLevel <= 3) {
          this.asideHidden = true
        }
        this.viewMarkers()
      } catch (err) {
        this.$router.go(0)
      }
    },
    moveMap () {
      if (this.map !== null) {
        const moveLatLon = new window.kakao.maps.LatLng(
          this.latPosition,
          this.lngPosition
        )
        this.map.setCenter(moveLatLon)
        sessionStorage.setItem('lat', this.latPosition)
        sessionStorage.setItem('lng', this.lngPosition)
        sessionStorage.setItem('level', this.zoomLevel)
        this.searchAddrFromCoords(moveLatLon, this.displayCenterInfo)
        const customLevel = this.getCustomLevel()
        if (customLevel <= 3) {
          this.asideHidden = true
        }
        this.viewMarkers()
      }
    },
    clickCurBtn () {
      if (navigator.geolocation) {
        const tmpThis = this
        navigator.geolocation.getCurrentPosition(function (position) {
          tmpThis.latPosition = position.coords.latitude
          tmpThis.lngPosition = position.coords.longitude
          tmpThis.moveMap()
        })
      }
    },
    geoSuccess (position) {
      this.latPosition = position.coords.latitude
      this.lngPosition = position.coords.longitude
      sessionStorage.setItem('lat', this.latPosition)
      sessionStorage.setItem('lng', this.lngPosition)
      sessionStorage.setItem('level', this.zoomLevel)
      this.initMap()
    },
    geoError () {
      this.initMap()
    },
    initLocations () {
      // 일단 최선으로 이렇게 세션 스토리지에 담아서 처리
      if (sessionStorage.getItem('lat') !== null) {
        this.latPosition = sessionStorage.getItem('lat')
        this.lngPosition = sessionStorage.getItem('lng')
        this.zoomLevel = sessionStorage.getItem('level')
        this.initMap()
      } else {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(
            this.geoSuccess,
            this.geoError
          )
        }
      }
    },
    initMap () {
      const container = document.getElementById('map')
      let options = {
        center: new window.kakao.maps.LatLng(
          this.latPosition,
          this.lngPosition
        ),
        level: this.zoomLevel
      }
      const map = new window.kakao.maps.Map(container, options)
      map.relayout()
      const zoomControl = new window.kakao.maps.ZoomControl()
      map.addControl(zoomControl, window.kakao.maps.ControlPosition.RIGHT)
      window.kakao.maps.event.addListener(map, 'dragend', this.setDragEndEvent)
      // window.kakao.maps.event.addListener(map, 'click', function (mouseEvent) {
      //   console.log(mouseEvent.latLng)
      //   // this.streetView(mouseEvent.LatLng.getLat(), mouseEvent.LatLng.getLng())
      // })

      window.kakao.maps.event.addListener(
        map,
        'zoom_changed',
        this.setZoomEvent
      )
      const geocoder = new window.kakao.maps.services.Geocoder()
      this.$store.commit('setMapThis', this)
      this.map = map
      this.geocoder = geocoder
      this.viewMarkers()
      // console.log('viewMarker1')
      this.searchAddrFromCoords(this.map.getCenter(), this.displayCenterInfo)
    },
    changePrice (pWon) {
      let won = pWon.toString().replace(/,/g, '')
      const arrWon = [
        '원',
        '만',
        '억',
        '조',
        '경',
        '해',
        '자',
        '양',
        '구',
        '간',
        '정'
      ]
      let changeWon = ''
      const pattern = /(-?[0-9]+)([0-9]{4})/
      while (pattern.test(won)) {
        won = won.replace(pattern, '$1,$2') // 원, 만원 변경 연결
      }
      let arrCnt = won.split(',').length - 1
      for (let ii = 0; ii < won.split(',').length; ii++) {
        if (arrWon[arrCnt] === undefined) {
          alert('값의 수가 너무 큽니다.')
          break
        }
        let tmpwon = 0
        for (let i = 0; i < won.split(',')[ii].length; i++) {
          let num1 = won.split(',')[ii].substring(i, i + 1)
          tmpwon = tmpwon + Number(num1)
        }
        if (tmpwon > 0) {
          changeWon += won.split(',')[ii] + arrWon[arrCnt]
        }
        arrCnt--
      }
      if (changeWon.indexOf('만') === changeWon.length - 1) {
        changeWon += '원'
      }
      if (changeWon.length === 0 || changeWon === '원') {
        changeWon = '0원'
      }
      return changeWon
    },
    goDetailsView (estateId) {
      if (estateId) {
        this.$router.push({ name: 'ViewEstate', params: { id: estateId } })
      }
    }
  },
  computed: {
    filteredSuggestions () {
      return [
        {
          data: this.suggestions
        }
      ]
    },
    ...mapGetters({
      suggestions: 'getSearchList',
      itemResults: 'getDetails',
      positions: 'getMarkers'
    })
  }
}
</script>
<style lang="scss" scoped>
@import "../css/sub.scss";
</style>



// WEBPACK FOOTER //
// src/pages/SearchEstate.vue